module.exports = __webpack_public_path__ + "img/16_5.48bcb3bb.png";